<template>
  <div class="d-flex flex-column">
    <template v-if="system">
      <div class="d-flex flex-column align-end justify-center">
        <div class="time ma-0">
          {{dateTimeToText(createdAt)}}
        </div>
        <div class="system">
          <slot/>
          <div v-if="file" class="file right">
            <ExternalLink
                :to="file.url"
                class="d-flex flex-row justify-end align-baseline mt-2"
                primary
            >
              <v-icon class="icon" color="primary">mdi-file-multiple-outline</v-icon>
              <div class="name">
                {{file.name}}
              </div>
            </ExternalLink>
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="owner">
      <div class="d-flex flex-row align-end justify-end">
        <div class="time">
          {{dateTimeToText(createdAt)}}
        </div>
        <div class="balloon right">
          <div class="d-flex flex-column">
            <slot/>
            <div v-if="file" class="file right">
              <ExternalLink
                  :to="file.url"
                  class="d-flex flex-row justify-end align-baseline mt-2"
                  white
              >
                <v-icon class="icon">mdi-file-multiple-outline</v-icon>
                <div class="name">
                  {{file.name}}
                </div>
              </ExternalLink>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="d-flex flex-row align-end justify-start">
        <FlexRow align="start">
          <v-avatar v-if="company && company.logoUrl" size="54" class="mt-2">
            <v-img :src="company.logoUrl" contain />
          </v-avatar>

          <FlexColumn :space="0">
            <Label v-if="company" :text="company.name" />

            <div class="balloon left">
              <slot/>
              <div v-if="file" class="file left">
                <ExternalLink
                    :to="file.url"
                    class="d-flex flex-row justify-start align-baseline mt-2"
                    primary
                >
                  <v-icon class="icon" color="primary">mdi-file-multiple-outline</v-icon>
                  <div class="name">
                    {{file.name}}
                  </div>
                </ExternalLink>
              </div>
            </div>
          </FlexColumn>
        </FlexRow>
        <div class="time">
          {{dateTimeToText(createdAt)}}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ExternalLink from "@/components/atoms/ExternalLink";
import ComponentMixin from "@/components/ComponentMixin";
import FlexRow from "./FlexRow";
import FlexColumn from "./FlexColumn";
import Label from "./Label";
export default {
  mixins: [ComponentMixin],
  name: "MessageBalloon",
  components: {Label, FlexColumn, FlexRow, ExternalLink},
  props: {
    owner: {
      type: Boolean
    },
    system: {
      type: Boolean
    },
    file: {
      type: Object
    },
    createdAt: {
      type: String
    },
    company: {
      type: Object
    },
    requestor: {
      type: Object
    }
  },
  computed: {
    rootClasses() {
      if (this.owner) {
        return "d-flex flex-column justify-end"
      }
      return "d-flex flex-column justify-start"
    },
    classes() {
      const values = ["balloon", "pa-4"]
      if (this.owner) {
        values.push("right")
      } else {
        values.push("left")
      }
      return values
    },
    fileClasses() {
      if (this.owner) {
        return "file right"
      }
      return "file left"
    }
  }
}
</script>

<style scoped>
.balloon {
  position: relative;
  display: inline-block;
  margin-bottom: 16px;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #fff;
  background: #2F3E6D;
  border-radius: 8px;
}

.balloon.right {
  color: #fff;
  background: #2F3E6D;
}

.balloon.left {
  color: inherit;
  background: lightgray;
}

.balloon p {
  margin: 0;
  padding: 0;
}

.system {
  position: relative;
  display: inline-block;
  margin-bottom: 16px;
  padding: 7px 32px;
  min-width: 120px;
  max-width: 100%;
  color: #fff;
  background: #949494;
  border-radius: 8px;
}

.time {
  font-size: 12px;
  margin-bottom: 24px;
  margin-left: 8px;
  margin-right: 8px;
}

.file.left {
  text-align: left;
}

.file.right {
  text-align: right;
}

.file .icon {
  color: white;
  margin-right: 4px;
}

.file .name {
  text-decoration: underline;
}
</style>
